import { Pressable, View } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import Text from "./text";
import variables from "../assets/variables";

const Chip = ({ text, onPress }) => {
  return (
    <Pressable onPress={() => onPress && onPress(text)}>
      <View
        style={{
          padding: 8,
          backgroundColor: variables.$disabledButton,
          alignSelf: "baseline",
          borderRadius: 40,
          flexDirection: "row",
          marginBottom: 10,
          marginRight: 15,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <MaterialCommunityIcons name="reload" size={16} color={"#ffff"} />
        <Text style={{ color: "#ffff", marginLeft: 5 }} numberOfLines={1}>
          {text}
        </Text>
      </View>
    </Pressable>
  );
};

export default Chip;
